/** Styl kompoennty pro nahrání souboru na server k tématu Erma */
export const FileuploadStyles = {
  background: "var(--erma-secondary-0)",
  borderColor: "var(--erma-secondary-220)",
  borderRadius: "var(--erma-border-radius-sm)",
  transitionDuration: "600s",
  header: {
    background: "var(--erma-secondary-50)",
    color: "var(--erma-secondary-0)",
    padding: "1.25rem",
    borderColor: "var(--erma-secondary-220)",
    borderWidth: "0px 0px 1px 0px",
    gap: "0.5rem"
  },
  content: {
    gat: '.5rem',
    padding: '.8rem'
  },
  basic: {
    gap: "0.5rem"
  },
  fileList: {
    gap: "0"
  },
  file: {
    padding: "0",
    gap: "0",
    borderColor: "{content.border.color}",
    info: {
      gap: "0"
    }
  },
};
